/* tslint:disable */

/**
 */
export class FirmwareForm {
    path?: string;
    id?: number;
    server_ip?: string;
    username?: string;
    password?: string;
    device_model_id?: number;
    version?: number;
    filename?: string;
    note?: string;
    company_id?: number;
    update_type?: string;
}
